import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import coachMarkStyles from '@swf/components/CoachMark/CoachMark.scss';

import DismissButton from '../../DismissButton/DismissButton';

import { TXTMOB_Create, TXTWCL_Click_this_button_in_order_to__ELL } from './Reminder.messages.json';
import styles from './Reminder.scss';

interface Props {
  onDismiss: () => void;
  className?: string;
}

const Reminder: React.FC<Props> = ({ onDismiss, className }) => (
  <div className={classNames(styles.container, className)}>
    <div className={coachMarkStyles.title}>
      <Translation {...TXTMOB_Create} />
    </div>
    <div className={coachMarkStyles.text}>
      <Translation {...TXTWCL_Click_this_button_in_order_to__ELL} />
    </div>
    <div className={classNames(coachMarkStyles.buttonContainer)}>
      <DismissButton onDismiss={onDismiss} />
    </div>
  </div>
);

export default Reminder;
